export function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <h1 className="font-titre font-bold text-7xl text-bleu-profond dark:text-white mb-4">404</h1>
      <p className="text-xl text-gris-texte dark:text-gray-300 mb-2">Page introuvable</p>
      <p className="text-gris-texte/70 dark:text-gray-400 mb-8 max-w-md">
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <button
        onClick={() => window.location.href = '/'}
        className="px-6 py-3 bg-bleu-profond text-white font-semibold rounded-lg hover:bg-bleu-profond/90 transition-colors"
      >
        Retour à l'accueil
      </button>
    </div>
  )
}
